export default "__VITE_ASSET__391d96a5__"